/* @flow */

import type { JSON } from 'common/types';
import { failure } from 'common/json/extract';

const decimal: JSON => number = (json: JSON) => {
  if (typeof json === 'number') {
    return json;
  } else if (typeof json === 'string') {
    return Number(json);
  }
  return failure(
    `Expecting decimal (number or string), got ${typeof json}`,
    () => Number(json)
  );
};

export default decimal;
